import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faBars, faPhone, faEnvelope, faMobile, faMagnifyingGlass, 
    faPaperPlane, faTrash, faPenToSquare, faEllipsisVertical, faCheck, faUser, faClock, faCalendar } from '@fortawesome/free-solid-svg-icons';

library.add(faFacebook, faInstagram,  faLinkedin, faPhone, faEnvelope, faBars, 
    faMobile, faMagnifyingGlass, faPaperPlane, faTrash, faPenToSquare, faEllipsisVertical, faCheck, faUser, faClock, faCalendar);
